import { GzEasmArtifactsInventoryWebComponent } from './component/GzEasmArtifactsInventoryWebComponent';

export { GzEasmArtifactsInventoryWebComponent };
